/* eslint-disable react/display-name */
import { FormLabel } from '@smartsheet/lodestar-core';
import React from 'react';

export interface WithDefaultDecoratorProps {
  children: React.ReactNode;
  id: string;
  label: string;
  title: string;
  value?: any;
  readonly?: boolean;
  error?: boolean;
}

export const WithDefaultDecorator =
  <P extends any>(Component: React.ComponentType<P>) =>
  (props: P & WithDefaultDecoratorProps) =>
    (
      <FormLabel id={props.id} label={props.label} description={props.title}>
        {inputProps => <Component {...props} {...inputProps} />}
      </FormLabel>
    );
